module.exports = __webpack_public_path__ + "media/images/com_img02-920a99e143775ece9be8aac105e679c3.png";